import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Sticky, Tag, Tabs, Tab, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Text, Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, ProductDiscountLabel, Discount, ProductDetailTitleView, ProductDetailPrice, ProductDetailUspsView, ProductDetailDisclaimerView } from '@grandvisionhq/fun-products';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import ConfigureContactLenses from '../../ConfigureContactLenses/ConfigureContactLensesContainer.js';
import Description from './components/Description/DescriptionContainer.js';

const Lenses = ({ addToCartRef , contactLensesConfiguratorConfig , ctaButton , currency , deliveryIndicatorConfig , descriptionConfig , hasSubscriptions =false , isSmallScreen , isProductLabelEnabled , labels , packPrice , subscriptionPrice , productTypeUsps , showStickyButton , stickyTop , variant , variantGroup , activeTabIndex , setActiveTabIndex , isSubscriptionSelected , productImageGallery , disclaimer ,  })=>{
    var ref2;
    const { isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const packPriceDiscount = packPrice === null || packPrice === void 0 ? void 0 : (ref2 = packPrice.discounted) === null || ref2 === void 0 ? void 0 : ref2.value.centAmount;
    const { Slots  } = useProductDetailSlots();
    const discountLabel = /*#__PURE__*/ React.createElement(React.Fragment, null, isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    }));
    const hidePackPriceInStickyCta = React.useMemo(()=>{
        var ref;
        const hasQuantityDiscountItems = Boolean((ref = contactLensesConfiguratorConfig.quantityDiscountItems) === null || ref === void 0 ? void 0 : ref.length);
        return hasQuantityDiscountItems;
    }, [
        contactLensesConfiguratorConfig.quantityDiscountItems
    ]);
    var ref1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-lenses"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: variant.brand,
        subtitle: variant.replacementFrequency
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variantGroup
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, productImageGallery), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside product-detail-lenses__aside",
        "aria-label": `${variant.brand} ${variant.replacementFrequency}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail-lenses",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, !isSmallScreen && /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: variant.brand,
        subtitle: variant.replacementFrequency
    }), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(Tag, {
        iconKey: variant.tag.key,
        label: variant.tag.value
    })), packPrice && !isSubscriptionSelected && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices",
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        className: "product-detail__price",
        originalPrice: packPrice.value.centAmount,
        currency: currency,
        discountedPrice: packPriceDiscount
    })), discountLabel), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), subscriptionPrice && isSubscriptionSelected && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        className: "product-detail__price",
        originalPrice: subscriptionPrice,
        currency: currency
    })), discountLabel), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variantGroup
    }), variant.excludedFromCheckout && /*#__PURE__*/ React.createElement(Text, null, variant.packageQuantity, ' ', variant.packageQuantity === 1 ? labels.lens : labels.lenses, " ", labels.perBox), !variant.excludedFromCheckout && hasSubscriptions && /*#__PURE__*/ React.createElement(Tabs, {
        onChange: setActiveTabIndex,
        activeTabIndex: activeTabIndex,
        variant: "secondary"
    }, /*#__PURE__*/ React.createElement(Tab, {
        label: labels.oneTimeTitle
    }), /*#__PURE__*/ React.createElement(Tab, {
        label: labels.subscriptionTitle
    })), !variant.excludedFromCheckout && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__configuration product-detail-lenses__configuration"
    }, /*#__PURE__*/ React.createElement(ConfigureContactLenses, swcHelpers.extends({}, contactLensesConfiguratorConfig, {
        isSubscriptionSelected: isSubscriptionSelected,
        hasSubscriptions: hasSubscriptions,
        variantGroup: variantGroup
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details",
        ref: addToCartRef
    }, !variant.excludedFromCheckout && isDeliveryFullDateEnabled && !isSubscriptionSelected && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "text"
    }))), ctaButton, Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null, isSmallScreen && showStickyButton && !!variant.price && (hidePackPriceInStickyCta ? /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton
    }) : /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (ref1 = packPriceDiscount ? packPriceDiscount : packPrice === null || packPrice === void 0 ? void 0 : packPrice.value.centAmount) !== null && ref1 !== void 0 ? ref1 : 0,
            currency: currency,
            centAmount: true,
            type: packPriceDiscount ? 'discount' : 'default'
        }),
        perBox: labels.perBox
    }))), /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), !variant.excludedFromCheckout && !isSubscriptionSelected && !isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "icon"
    })), productTypeUsps && /*#__PURE__*/ React.createElement(ProductDetailUspsView, {
        items: productTypeUsps
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-lenses__description"
    }, /*#__PURE__*/ React.createElement(Description, swcHelpers.extends({}, descriptionConfig, {
        variant: variant
    }))), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }, /*#__PURE__*/ React.createElement(ProductDetailDisclaimerView, {
        disclaimer: disclaimer
    })));
};
var Lenses$1 = Lenses;

export { Lenses, Lenses$1 as default };
//# sourceMappingURL=Lenses.js.map
